import { render, staticRenderFns } from "./LoyaltyProgramForm.template.vue?vue&type=template&id=2746b968&scoped=true&"
var script = {}
import style0 from "./LoyaltyProgramForm.template.vue?vue&type=style&index=0&id=2746b968&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2746b968",
  null
  
)

export default component.exports